// extracted by mini-css-extract-plugin
module.exports = {"VidaDropdownContainer":"VidaDropdown_VidaDropdownContainer__2_Z8m","LabelContainer":"VidaDropdown_LabelContainer__2pRAt","DropdownSelect":"VidaDropdown_DropdownSelect__Ee7qX"};